// @flow
import * as api from "../data/firebase-data";
import * as actionTypes from "../constants/action-types";
import type Town from "../models/town";

/** EXAMPLE ACTIONS

 ***ASYNC EXAMPLE:

 export const doSomeAction = (foo): (any => void) => {
    function thunk(dispatch) {
        someAsyncFunction(foo)
            .then((result: mixed) => {
                dispatch({ type: actionTypes.SOME_ACTION_SUCCESS, payload: {result}});
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.SOME_ACTION_FAIL, payload: {error} });
            });
    }
    thunk.interceptOnOffline = true;
    return thunk;
};


 ***SYNCHRONOUS EXAMPLE:

 export const soSomeAction = (api: DataType): ActionType => (
 {
        type: actionTypes.SOME_ACTION,
        api
    }
 );

 **/


/**
 * updates a town
 * @param {Object} town - town to update
 */
export const saveTown = (town: Town): (any => void) => {
    function thunk(dispatch) {
        api.updateTown(town)
            .then((result: mixed) => {
                dispatch({ type: actionTypes.UPDATE_TOWN_SUCCESS, payload: { result } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.UPDATE_TOWN_FAIL, payload: { error } });
            });
    }

    thunk.interceptOnOffline = true;
    return thunk;
};

